import axios from 'axios';
import Config from '../core/Config';

type AttachmentType = 'comments' | 'topics';

export const useUploadAttachmentFile = (attachmentType: AttachmentType) => {
  const config: Config = (window as any).__hugotconfig__;

  const uploadFile = async (file: File, topicId: string) => {
    const params = new FormData();
    params.append('attachment[file]', file);

    await axios
      .post(
        `${config.LIFT_REPORT_API_BASE}/project_${
          attachmentType === 'comments' ? 'comments' : 'topics'
        }/${topicId}/attachments`,
        params,
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Basic ZGV2OmthaXplbjUwMg==',
          },
        },
      )
      .catch(() => {
        throw new Error('upload failed.');
      });
  };

  return {
    uploadFile,
  };
};
